import React from "react";
import { FaUser, FaUsers } from "react-icons/fa";
import { IoMdSettings } from "react-icons/io";
import { FaLocationDot, FaMapLocationDot } from "react-icons/fa6";

// show roles: "provider" | "nurse" | "nurse_admin" (nurse with is_facility_admin)
// carecoResource: when set, providers must have userAcl.careco[carecoResource].all (e.g. 1). Nurses / nurse_admin ignore ACL.
export const settings_sidebar_tabs = [
  {
    id: 1,
    title: "User Profile",
    slug: "user_profile",
    Icon: FaUser,
    iconProps: { size: 20 },
    show: ["nurse"],
  },
  {
    id: 2,
    title: "Report a Problem",
    slug: "report_a_problem",
    Icon: IoMdSettings,
    iconProps: { size: 22 },
    show: ["provider"],
  },
  {
    id: 3,
    title: "Locations",
    slug: "locations",
    Icon: FaLocationDot,
    iconProps: { size: 20 },
    show: ["provider", "nurse_admin"],
  },
  {
    id: 4,
    title: "Facility Staff",
    slug: "facility_staff",
    Icon: FaUsers,
    iconProps: { size: 20 },
    show: ["provider"],
  },
  {
    id: 5,
    title: "Facility Location Groups",
    slug: "facility_location_groups",
    Icon: FaMapLocationDot,
    iconProps: { size: 20 },
    show: ["provider"],
  },
  {
    id: 6,
    title: "Practice Staff",
    slug: "practice_staff",
    Icon: FaUsers,
    iconProps: { size: 20 },
    show: ["provider"],
  },
];

const allowedTabsForProvider = ['report_a_problem'];

export function hasCarecoAllAccess(careco, resourceKey) {
  if (!resourceKey || careco == null || typeof careco !== "object") return false;
  const node = careco[resourceKey];
  if (node == null || typeof node !== "object") return false;
  const all = node.all;
  return all === 1 || all === "1";
}

export function getNurseLocationsCount(nurseLocationsData) {
  if (Array.isArray(nurseLocationsData?.data)) return nurseLocationsData.data.length;
  if (Array.isArray(nurseLocationsData)) return nurseLocationsData.length;
  if (nurseLocationsData?.meta?.total !== undefined && nurseLocationsData?.meta?.total !== null) {
    return Number(nurseLocationsData.meta.total) || 0;
  }
  return null;
}

export function shouldShowSettingsTab(tab, { authData, userAcl, nurseLocationsData, isNurseLocationsLoading } = {}) {
  const isProvider = !!authData?.is_provider;
  const nurseLocationsCount = getNurseLocationsCount(nurseLocationsData);

  const passesRole = tab?.show?.some((role) => {
    if (role === "provider") return isProvider;
    if (role === "nurse") return !isProvider;
    if (role === "nurse_admin") {
      if (isProvider || !authData?.is_facility_admin) return false;
      if (nurseLocationsCount === null) return !!isNurseLocationsLoading;
      return nurseLocationsCount > 0;
    }
    return false;
  });
  if (!passesRole) return false;

  const tabSlug = tab?.slug;
  if (!tabSlug || !isProvider) return true;

  if (allowedTabsForProvider.includes(tabSlug)) return true;

  return hasCarecoAllAccess(userAcl?.careco, tabSlug);
}

export function getVisibleSettingsTabs(tabs, params = {}) {
  return tabs.filter((tab) => shouldShowSettingsTab(tab, params));
}
